import {
  differenceInCalendarDays,
  formatDistance,
  formatRelative,
} from 'date-fns'
import { enUS } from 'date-fns/locale'

// date-fns' stock relative formats append the clock time ("last Tuesday at
// 2:00 PM"); a table cell only wants the day. Overriding the locale's token
// map is the library's supported way to say so — never string surgery on
// another library's human-readable output.
const RELATIVE_DAY_FORMAT: Record<
  Parameters<typeof enUS.formatRelative>[0],
  string
> = {
  lastWeek: "'last' eeee",
  yesterday: "'yesterday'",
  today: "'today'",
  tomorrow: "'tomorrow'",
  nextWeek: 'eeee',
  other: 'P',
}

const dayOnlyLocale: typeof enUS = {
  ...enUS,
  formatRelative: (token) => RELATIVE_DAY_FORMAT[token],
}

/**
 * The "Last seen" cell's text (LG-362 §8): day names for the recent past
 * ("today", "yesterday", "last Tuesday"), distances beyond that ("4 days
 * ago", "about a month ago") — the hybrid the ticket's examples show.
 * `now` is injected for testability, same reasoning as history-log.ts.
 */
export function formatLastSeen(at: Date, now: Date): string {
  const days = differenceInCalendarDays(now, at)
  if (days >= 0 && days < 7) {
    return formatRelative(at, now, { locale: dayOnlyLocale })
  }
  return formatDistance(at, now, { addSuffix: true })
}
